import { ApiClient } from '@busbook/ui';

/**
 * The customer app talks to its own origin: the reverse proxy (and the Vite dev
 * proxy) forward `/api` to the API, which is what makes Host-based tenant
 * resolution work without any tenant id in the client.
 */
export const api = new ApiClient({
  baseUrl: '/api/v1',
  storageKey: 'busbook.customer.tokens',
  refreshPath: '/public/auth/refresh',
  onAuthLost: () => {
    window.dispatchEvent(new CustomEvent('busbook:auth-lost'));
  },
});
